import { render } from "./App.vue?vue&type=template&id=701aa499&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=701aa499&lang=scss"
import "./App.vue?vue&type=style&index=1&id=701aa499&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701aa499"]])

export default __exports__